import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import moment from 'moment';
import FaUser from 'react-icons/lib/fa/user';
import uniqueId from 'lodash.uniqueid';

import HistoryCalendar from './HistoryCalendar';
import ProjectDetailsHeader from '../ProjectDetailsHeader';
import Styles from './ChangeHistoryBox.styles';

class ChangeHistoryBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.setState({ selectedDate: value });
  }

  renderHistoryList() {
    const { history } = this.props;
    const filteredHistory = history.filter(item =>
      moment(item.createdAt).isSame(moment(this.state.selectedDate), 'day'),
    );

    const rows = filteredHistory.map((element, number) => {
      const isMyOwnChange = element.createdBy && element.createdBy.key === this.props.auth.uid;
      const userIconColor = isMyOwnChange ? '#f3d415' : 'rgb(206, 215, 217)';
      return (
        <div
          key={uniqueId('history')}
          style={{ display: 'flex', flexDirection: 'row', paddingBottom: '10px' }}
        >
          <div
            style={{
              color: 'rgb(23, 232, 128)',
              fontSize: '18px',
              fontWeight: 'bold',
              marginRight: '10px',
            }}
          >{`${number + 1}. `}</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: '5px',
              }}
            >
              <FaUser style={{ color: userIconColor, marginRight: '5px' }} size={12} />
              <div
                style={{ color: 'rgb(206, 215, 217)', fontSize: '12px', verticalAlign: 'bottom' }}
              >
                {element.createdBy.displayName}
              </div>
            </div>
            <div style={{ fontSize: '12px' }}>
              {moment(element.createdAt).format('dddd, Do MMMM YYYY [at] HH:mm')}
            </div>
          </div>
        </div>
      );
    });
    return <div style={{ paddingLeft: '20px' }}> {rows} </div>;
  }

  render() {
    const { history, auth } = this.props;
    return (
      <div style={Styles.historyBoxWrapper}>
        {history &&
          history.length > 0 && (
            <div>
              <ProjectDetailsHeader text="Entire history of edits" />
              <HistoryCalendar
                history={history}
                onChange={this.onChange}
                value={this.state.selectedDate}
                auth={auth}
              />
              {this.renderHistoryList()}
            </div>
          )}
      </div>
    );
  }
}

ChangeHistoryBox.defaultProps = {
  history: {},
};

ChangeHistoryBox.propTypes = {
  history: PropTypes.arrayOf(Object),
  auth: PropTypes.shape({ uid: PropTypes.string.isRequired }).isRequired,
};

export default Radium(ChangeHistoryBox);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ChangeHistoryBox/ChangeHistoryBox.js